import { common, grey, primary } from 'src/theme/palette';

export const toggleButtonStyle = (isLight) => ({
    borderRadius: '50px !important',
    border: '1px solid rgba(145, 158, 171, 0.24) !important',
    m: '4px 8px 4px 0px !important',
    p: '6px 14px 6px 8px',
    height: '36px',
    color: isLight ? grey[700] : grey[400],
    bgcolor: isLight ? 'rgba(145, 158, 171, 0.04) !important' : 'transparent !important',
    boxShadow: 'none !important',
    fontWeight: 500,
    textTransform: 'none !important',
    fontSize: '13px',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
        bgcolor: 'rgba(0, 167, 111, 0.04) !important',
        borderColor: 'rgba(0, 167, 111, 0.32) !important',
    },
    '&.Mui-selected': {
        borderColor: `${primary.main} !important`,
        bgcolor: 'rgba(0, 167, 111, 0.08) !important',
        color: `${primary.main} !important`,
        fontWeight: 600,
    }
});
export const smallToggleButtonStyle = (isLight) => ({
    ...toggleButtonStyle(isLight),
    height: 32,
    fontSize: 12,
    p: '4px 12px 4px 8px',
    m: '3px 6px 3px 0px !important',
});

export const chipToggleButtonStyle = (isLight) => ({
    borderRadius: '50px !important',
    border: '1px solid rgba(145, 158, 171, 0.2) !important',
    m: '3px 5px 3px 0px !important',
    p: '3px 12px !important',
    height: '28px',
    minWidth: 'auto',
    color: isLight ? grey[600] : grey[400],
    bgcolor: 'transparent !important',
    boxShadow: 'none !important',
    fontWeight: 500,
    textTransform: 'none !important',
    fontSize: '12px',
    lineHeight: 1,
    letterSpacing: '0.01em',
    transition: 'all 0.15s ease',
    '&:hover': {
        bgcolor: 'rgba(0, 167, 111, 0.04) !important',
        borderColor: 'rgba(0, 167, 111, 0.3) !important',
        color: '#00A76F',
    },
    '&.Mui-selected': {
        borderColor: 'rgba(0, 167, 111, 0.4) !important',
        bgcolor: 'rgba(0, 167, 111, 0.08) !important',
        color: '#00A76F !important',
        fontWeight: 600,
    }
});

export const toggleButtonStyleV2 = (isLight) => ({
    borderRadius: '50px !important',
    border: `solid 1px ${primary.btn} !important`,
    p: '4px 12px 4px 5px',
    height: '32px',
    color: isLight ? grey[700] : grey[400],
    bgcolor: 'transparent !important',
    fontWeight: '400'
});
export const reminderTitleStyle = {
    fontWeight: '700',
    fontSize: '18px',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%'
};

export const stackStyle = {
    width: '100%',
    justifyContent: 'flex-start'
};

export const timelineItemStyle = {
    '::before': {
        display: 'none'
    },
    marginBottom: 2,
    borderRadius: 2,
    p: '20px',
    border: '1px dashed',
    borderColor: 'primary.paperColor'
};

export const yesBtnStyleForLoader = (isLoader) => ({
    margin: '0px 10px',
    padding: '5px 20px',
    fontSize: '14px',
    borderRadius: '8px',
    minWidth: '100px',
    boxShadow: '0px 8px 16px rgba(0, 171, 85, 0.24)',
    bgcolor: isLoader ? '' : common.mintyZest,
});

export const appointmentTypoStyle = {
    fontWeight: 600,
    mb: 1.5,
    color: 'text.secondary',
};

export const assignToUserBoxStyle = {
    minHeight: '53px',
    display: 'flex',
    alignItems: 'center'
};